import React from 'react';
import { Row, Col, Card, Statistic, Typography, List, Avatar, Tag } from 'antd';
import { 
  UserOutlined, 
  ContactsOutlined, 
  MailOutlined, 
  FolderOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { useQuery } from 'react-query';
import { contactsAPI, emailsAPI } from '../../services/api';
import { useNavigate } from 'react-router-dom';

const { Title, Text } = Typography;

const Dashboard = () => {
  const navigate = useNavigate();

  const { data: contactsData } = useQuery('contacts', () => contactsAPI.getAll());
  const { data: emailsData } = useQuery('email-logs', () => emailsAPI.getLogs());

  const contacts = contactsData?.data?.data?.contacts || [];
  const emailLogs = emailsData?.data?.data?.emailLogs || [];

  const stats = {
    totalContacts: contacts.length,
    recentContacts: contacts.slice(0, 5),
    totalEmails: emailLogs.length,
    recentEmails: emailLogs.slice(0, 5)
  };

  const quickActions = [
    {
      title: 'Ajouter un contact',
      icon: <PlusOutlined />,
      color: '#1890ff',
      onClick: () => navigate('/contacts?action=add')
    },
    {
      title: 'Envoyer un email',
      icon: <MailOutlined />,
      color: '#52c41a',
      onClick: () => navigate('/emails?action=send')
    },
    {
      title: 'Gérer les familles',
      icon: <FolderOutlined />,
      color: '#fa8c16',
      onClick: () => navigate('/families')
    }
  ];

  return (
    <div>
      <div className="page-header">
        <Title level={2}>Tableau de bord</Title>
        <Text type="secondary">Bienvenue dans votre système de gestion des contacts</Text>
      </div>

      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Total Contacts"
              value={stats.totalContacts}
              prefix={<ContactsOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Emails Envoyés"
              value={stats.totalEmails}
              prefix={<MailOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Familles"
              value={4}
              prefix={<FolderOutlined />}
              valueStyle={{ color: '#fa8c16' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title="Utilisateurs Actifs"
              value={1}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#722ed1' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title="Actions Rapides" style={{ marginBottom: 16 }}>
            <Row gutter={[16, 16]}>
              {quickActions.map((action, index) => (
                <Col xs={24} sm={8} key={index}>
                  <Card
                    hoverable
                    onClick={action.onClick}
                    style={{ textAlign: 'center', cursor: 'pointer' }}
                    styles={{ body: { padding: 24 } }}
                  >
                    <div style={{ fontSize: 24, color: action.color, marginBottom: 8 }}>
                      {action.icon}
                    </div>
                    <Text strong>{action.title}</Text>
                  </Card>
                </Col>
              ))}
            </Row>
          </Card>

          <Card title="Contacts Récents">
            <List
              dataSource={stats.recentContacts}
              renderItem={(contact) => (
                <List.Item
                  onClick={() => navigate(`/contacts/${contact.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <List.Item.Meta
                    avatar={<Avatar icon={<UserOutlined />} />}
                    title={`${contact.first_name} ${contact.last_name}`}
                    description={contact.company || contact.email}
                  />
                  {contact.subFamily && (
                    <Tag color={contact.subFamily.family?.color}>
                      {contact.subFamily.family?.name}
                    </Tag>
                  )}
                </List.Item>
              )}
              locale={{ emptyText: 'Aucun contact récent' }}
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card title="Emails Récents">
            <List
              dataSource={stats.recentEmails}
              renderItem={(email) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={<Avatar icon={<MailOutlined />} />}
                    title={email.subject}
                    description={
                      <div>
                        <Text type="secondary">
                          Envoyé le {new Date(email.sent_at).toLocaleDateString('fr-FR')}
                        </Text>
                        <br />
                        <Text type="secondary">
                          {email.recipients?.length || 0} destinataire(s)
                        </Text>
                      </div>
                    }
                  />
                  <Tag color={email.status === 'sent' ? 'green' : 'orange'}>
                    {email.status === 'sent' ? 'Envoyé' : 'En attente'}
                  </Tag>
                </List.Item>
              )}
              locale={{ emptyText: 'Aucun email récent' }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
